import { useEffect, useState } from 'react'
import { getNewsletterLocations } from '@/app/actions/getNewsletterLocations'
import useCurrentPage from '@/hooks/use-current-page'
import { REGIONS } from '@/data'

export const useNewsletterLocations = () => {
  const [locations, setLocations] = useState<LocationOption[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const { currentLanguage } = useCurrentPage()

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        setLoading(true)
        setError(null)
        const language = Array.isArray(currentLanguage) ? currentLanguage[0] : currentLanguage
        const locationData = await getNewsletterLocations(language || REGIONS.EN_US)
        setLocations(locationData)
      } catch (err) {
        console.error('Failed to fetch newsletter locations:', err)
        setError('Failed to load locations')
        // Fallback to empty array
        setLocations([])
      } finally {
        setLoading(false)
      }
    }

    fetchLocations()
  }, [currentLanguage])

  return {
    locations,
    loading,
    error,
  }
}
